import React from 'react'
import NavbarNew from '../Components/NavbarNew'
const logisticManagerDashboard = () => {
  return (
    <div class="container-fluid">
      <NavbarNew />
      <p>Hello</p>
    </div>
  )
}

export default logisticManagerDashboard;